import {REMOTE_STORAGE} from '@/util/table-setting-constant';
import {misConfigureListUser, saveTableColumnMsg} from '../api/misConfigApi';

export default {
  props: {
    columnCache: {
      type: String,
      default: ''
    },
    tableSettingConfig: {
      type: Object,
      default() {
        return {
          // 列是否可以拖拽，命名尽量和html属性draggable保持一致
          columnDraggable: true,
          // 行是否可以拖拽
          rowDraggable: false,
          // 获取表格配置的api
          getApi: misConfigureListUser,
          // 保存表格配置的api
          saveApi: saveTableColumnMsg,
          // 保存方式，如果不是remoteStorage,getApi和saveApi都不会起作用
          // columnDraggable和rowDraggable不影响remote,因为width和visible有可能需要保存在服务器,
          storage: REMOTE_STORAGE
        };
      }
    },
    // 表格样式改变的回调函数
    handleTableSettingUpdate: Function,
    // 切换表格样式的回调
    handleMisConfigureChange: Function
  },
  methods: {
    checkMethod({column}) {
      const editRules = this.getEditRules();
      if (!editRules) {
        return true;
      }
      for (const key in editRules) {
        if (column.property !== key) {
          continue;
        }
        for (const rule of editRules[key]) {
          // 由于checkMethod是针对列的，所以只能判断required属性
          if (rule.required === true) {
            return false;
          }
        }
      }
      return true;
    },
    getEditRules() {
      return this.editRules;
    }
  },
  computed: {
    realTableSettingConfig() {
      const defaultConfig = {
        columnDraggable: true,
        rowDraggable: false,
        getApi: misConfigureListUser,
        saveApi: saveTableColumnMsg,
        storage: REMOTE_STORAGE
      };
      if (!this.tableSettingConfig) {
        return defaultConfig;
      }
      return Object.assign(defaultConfig, this.tableSettingConfig);
    },
    realCustomConfig() {
      const defaultConfig = {checkMethod: this.checkMethod};
      if (!this.customConfig) {
        return defaultConfig;
      }
      return Object.assign(defaultConfig, this.customConfig);
    }
  }
};
